import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { useState } from "react";
import { SortDescriptor } from "@progress/kendo-data-query";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";



const PositionTable = (props: any) => {
  
  const navigate = useNavigate()
  const draftKey  = props.draftKey
  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "desc" },
  ];

  const [sort, setSort] = useState(initialSort);

  const viewButton = (props: GridCellProps) => {    
    
    return (
      <td>
        {draftKey !== undefined ? 
          <button  className="applyButton"> View</button> :
          <button onClick={(e: any) => navigate('/position-details', { state: { jobId: props.dataItem.job_id, positionName: props.dataItem.job_title, companyName: props.dataItem.company, jobStatus: props.dataItem.job_status }})}
            className="applyButton">
              View
          </button> 
        }
      </td>
    );
  };

  const rowClick = (e: any) => {
    props.rowClick(e);
  };

  const redirection = (jobId: string, positionName: string, companyName: string) => {
    navigate('../position-details', { state: { jobId: jobId, positionName: positionName, companyName: companyName }})
  }

  return (
    <Grid
      data={props.state.items}
      onPageChange={props.pageChange}
      total={props.state.total}
      skip={props.state.skip}
      pageable={props.state.pageable}
      pageSize={props.state.pageSize}
      onRowClick={(e) => rowClick(e)}
      sortable={true}
      sort={sort}
      onSortChange={(e) => {
        setSort(e.sort);
        props.setSort(e.sort);
        props.applySort(e.sort);
      }}
    >
      <GridNoRecords>
        <div className="noData">
          <Icon icon="mdi:smiley-neutral-outline" />
          No data to display
        </div>
      </GridNoRecords>
      <Column field="positionName" title="Role" width="140px"  cell={(props: GridCellProps) =>  jobTitleCell(props, (candidateLoginId: string, positionName: string, companyName: string) => redirection(candidateLoginId, positionName, companyName))}/>
      <Column field="Skills" title="Skills" cell={skillsCell} />
      <Column field="experienceLevel" title="Experience" cell={experienceCell}/>
      <Column field="resource" title="Resources" cell={resourceCountCell} />
      {/* <Column field="rate" title="Rate" cell={rateCell}/> */}
      <Column field="allocated_to" title="AllocatedTo"  />
      <Column field="profiles" title="Position Status" cell={profileCell} width="190px"/>
      <Column field="profiles" title="Opened for" cell={createdDateCell} />
      <Column cell={viewButton}  width="70px" />
    </Grid>
  )
}

export default PositionTable;

const createdDateCell = (props: GridCellProps) => {
  return (
    <td>
      {new Date(parseInt(props.dataItem.created_date)).toDateString()}
    </td>
  )
}

const skillsCell = (props: GridCellProps) => {

  let length = props.dataItem.skills && props.dataItem.skills.length;

  return (
    <td >
       <div className="skillsWrap">
        {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number)  => {
           return ((item) +  (key < length-1 ?     ' , ' : ''))          })}
      </div>
    </td>
  );
};

const resourceCountCell = (props: GridCellProps) => {
  return <td>{props.dataItem.active_count}</td>;
};

const experienceCell = (props: GridCellProps) => {
  return <td>{props.dataItem.experience_level ? props.dataItem.experience_level.min + " - " + props.dataItem.experience_level.max   + " Years" : 'Not Mentioned'}</td>
};

const profileCell = (props: GridCellProps) => {

  return (
    <td>
      {props.dataItem.position_status && props.dataItem.position_status.map((item: any) => {
        return (
          `${Object.keys(item)}: ${Object.values(item)}`
        )
      })}
    </td>
  )
}

const  jobTitleCell = (props: GridCellProps, redirection: any) => {

  let currentDate = new Date().getTime()
  let dateOfRegistration = props.dataItem.created_date
  var diff =(currentDate -  dateOfRegistration) / 1000;
  diff /= (60 * 60);
  let diff2 = Math.abs(Math.round(diff));

  return (
    <td className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div className="userInfo" onClick={() => redirection(props.dataItem.job_id, props.dataItem.job_title, props.dataItem.company)}>
        {props.dataItem.job_title}
      </div>
    </td>
  )
}
